function setupDrifciak(root) {
  const scope = root.matches?.('[data-dc-section]') ? [root] : root.querySelectorAll('[data-dc-section]');
  for (const section of scope) {
    if (section.dataset.dcReady) continue;
    section.dataset.dcReady = 'true';
    const controller = new AbortController();
    section.dcController = controller;
    const listen = (node, type, handler) => node?.addEventListener(type, handler, { signal: controller.signal });
    const slides = Array.from(section.querySelectorAll('[data-dc-slide]'));
    const variants = Array.from(section.querySelectorAll('[data-dc-variant]'));
    const form = section.querySelector('.dc-product-form');
    const buy = form?.querySelector('.dc-buy');
    const status = form?.querySelector('[data-dc-status]');
    const price = section.querySelector('[data-dc-price]');
    const topValue = (position) => section.querySelector('[data-dc-option="' + position + '"]:checked')?.value;
    const pieces = Array.from({ length: 3 }, () => [topValue(1), topValue(2)]);
    let active = 0;
    let revision = 0;
    let animations = [];
    let busy = false;
    const coneChoice = section.querySelector('[data-dc-cones]');
    const preview = section.querySelector('[data-dc-mobile-preview]');
    const previewImage = preview?.querySelector('img');
    const quantity = () => Number(form?.querySelector('[name="quantity"]:checked')?.value || 1);
    const findVariant = (piece) => variants.find((v) => v.dataset.dcOption1 === piece[0] && v.dataset.dcOption2 === piece[1]);
    const money = (cents) => new Intl.NumberFormat(section.dataset.dcCurrency === 'PLN' ? 'pl-PL' : document.documentElement.lang || 'pl', { style: 'currency', currency: section.dataset.dcCurrency || 'PLN' }).format(cents / 100);
    const showImage = async (variant) => {
      const token = ++revision;
      const next = slides.find((slide) => slide.dataset.dcImageId === variant?.dataset.dcImage);
      if (!next) return;
      const image = next.querySelector('img');
      try {
        if (image) {
          image.loading = 'eager';
          await image.decode();
        }
      } catch {
        return;
      }
      if (token !== revision || controller.signal.aborted) return;
      if (previewImage && image) {
        previewImage.src = image.currentSrc || image.src;
        previewImage.removeAttribute('srcset');
        previewImage.alt = variant.dataset.dcTitle;
      }
      animations.forEach((animation) => animation.cancel());
      animations = [];
      slides.forEach((slide) => {
        if (slide.classList.contains('dc-slide-leaving')) slide.hidden = true;
        slide.classList.remove('dc-slide-leaving');
      });
      const previous = slides.find((slide) => !slide.hidden);
      if (previous === next) return;
      next.hidden = false;
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || !next.animate) {
        slides.forEach((slide) => { slide.hidden = slide !== next; });
        return;
      }
      if (previous) {
        previous.classList.add('dc-slide-leaving');
        animations.push(previous.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 180, easing: 'ease-out' }));
      }
      animations.push(next.animate([{ opacity: 0, transform: 'scale(1.015)' }, { opacity: 1, transform: 'scale(1)' }], { duration: 180, easing: 'ease-out' }));
      await Promise.allSettled(animations.map((animation) => animation.finished));
      if (token !== revision) return;
      slides.forEach((slide) => {
        slide.hidden = slide !== next;
        slide.classList.remove('dc-slide-leaving');
      });
    };
    const sticky = section.querySelector('[data-dc-sticky]');
    const stickyBuy = section.querySelector('[data-dc-sticky-add]');
    const dialog = section.querySelector('[data-dc-zoom]');
    const zoomOpen = section.querySelector('[data-dc-zoom-open]');
    const random = section.querySelector('[data-dc-random]');
    random.hidden = false;
    zoomOpen.hidden = false;
    listen(random, 'click', () => {
      const choices = variants.filter((v) => v.dataset.dcReady === 'true' && v !== findVariant(pieces[active]));
      if (!choices.length) return;
      const picked = choices[Math.floor(Math.random() * choices.length)];
      pieces[active] = [picked.dataset.dcOption1, picked.dataset.dcOption2];
      update();
    });
    let zoomTrigger = zoomOpen;
    const openZoom = (event) => {
      zoomTrigger = event.currentTarget;
      const chosen = findVariant(pieces[active]);
      const source = slides.find((slide) => slide.dataset.dcImageId === chosen?.dataset.dcImage)?.querySelector('img');
      if (!source) return;
      const target = dialog.querySelector('img');
      target.src = source.currentSrc || source.src;
      target.alt = chosen.dataset.dcTitle;
      dialog.showModal();
      stickyVisibility();
    };
    listen(zoomOpen, 'click', openZoom);
    listen(preview, 'click', openZoom);
    listen(section.querySelector('[data-dc-zoom-close]'), 'click', () => dialog.close());
    listen(dialog, 'click', (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    listen(dialog, 'close', () => zoomTrigger.focus({ preventScroll: true }));
    listen(stickyBuy, 'click', () => form.requestSubmit(buy));
    const stickyVisibility = () => {
      const rect = buy?.getBoundingClientRect();
      sticky.hidden = !rect || rect.bottom >= 0 || dialog.open;
      if (preview) {
        const galleryRect = section.querySelector('.dc-gallery-stage').getBoundingClientRect();
        const formRect = form.getBoundingClientRect();
        preview.hidden = !matchMedia('(max-width: 749px)').matches || galleryRect.bottom > 0 || formRect.bottom < 140 || dialog.open;
      }
    };
    document.addEventListener('scroll', stickyVisibility, { capture: true, passive: true, signal: controller.signal });
    listen(window, 'resize', stickyVisibility);
    listen(dialog, 'close', stickyVisibility);
    const revealTargets = section.querySelectorAll('.dc-reference-content > section');
    let revealObserver;
    if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      revealObserver = new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('dc-revealed');
        revealObserver.unobserve(entry.target);
      }), { threshold: 0.08 });
      revealTargets.forEach((target) => { target.classList.add('dc-reveal'); revealObserver.observe(target); });
    }
    listen(controller.signal, 'abort', () => { revealObserver?.disconnect(); dialog.close(); });
    const update = () => {
      const count = quantity();
      if (active >= count) active = 0;
      const chosen = findVariant(pieces[active]);
      section.querySelectorAll('[data-dc-option]').forEach((input) => {
        input.checked = input.value === pieces[active][Number(input.dataset.dcOption) - 1];
      });
      section.querySelectorAll('[data-dc-piece]').forEach((row) => {
        const index = Number(row.dataset.dcPiece) - 1;
        row.toggleAttribute('data-dc-active', index === active);
        row.querySelectorAll('select').forEach((select) => {
          select.value = pieces[index][Number(select.dataset.dcPieceOption) - 1];
        });
      });
      section.querySelectorAll('[data-dc-color-name]').forEach((label) => {
        const card = label.closest('.dc-quantity-option');
        const n = Number(card?.querySelector('[name="quantity"]')?.value || 1);
        label.textContent = pieces.slice(0, n).map((piece) => piece.join(' / ')).join(' · ');
      });
      section.querySelectorAll('[data-dc-body-name]').forEach((label) => { label.textContent = pieces[active][0]; });
      const selected = form?.querySelector('[data-dc-selected-variant]');
      if (selected) selected.value = chosen?.dataset.dcVariant || '';
      if (price) {
        price.textContent = chosen?.dataset.dcPriced === 'true' ? chosen.dataset.dcPrice : price.dataset.dcComingLabel;
        price.classList.toggle('dc-price-coming', chosen?.dataset.dcPriced !== 'true');
      }
      section.querySelectorAll('[data-dc-package-price]').forEach((target) => {
        const n = Number(target.dataset.dcPackagePrice);
        const bundle = pieces.slice(0, n).map(findVariant);
        target.replaceChildren();
        if (bundle.some((v) => !v || v.dataset.dcPriced !== 'true')) {
          target.textContent = price?.dataset.dcComingLabel || '';
          return;
        }
        const total = bundle.reduce((sum, v) => sum + Number(v.dataset.dcCents), 0);
        const strong = document.createElement('strong');
        strong.textContent = money(Math.round(total * (n === 3 ? 0.9 : n === 2 ? 0.95 : 1)));
        target.append(strong);
        if (n > 1) {
          const original = document.createElement('s');
          original.textContent = money(total);
          target.append(original);
        }
      });
      const available = pieces.slice(0, count).every((piece) => findVariant(piece)?.dataset.dcReady === 'true');
      if (buy) {
        buy.disabled = busy || !available;
        buy.textContent = busy ? buy.dataset.dcAddingLabel : available ? buy.dataset.dcAddLabel : buy.dataset.dcSoonLabel;
      }
      const summary = section.querySelector('[data-dc-selection]');
      summary.textContent = summary.dataset.dcLabel.replace('__number__', String(active + 1)) + ' · ' + pieces[active].join(' / ');
      if (preview) preview.querySelector('[data-dc-preview-label]').textContent = summary.textContent;
      stickyBuy.disabled = buy.disabled;
      stickyBuy.textContent = buy.textContent;
      const base = pieces.slice(0, count).reduce((sum, piece) => sum + Number(findVariant(piece)?.dataset.dcCents || 0), 0);
      const total = Math.round(base * (count === 3 ? 0.9 : count === 2 ? 0.95 : 1)) + (coneChoice?.checked ? Number(coneChoice.dataset.dcCents) : 0);
      section.querySelector('[data-dc-sticky-price]').textContent = money(total);
      const orderSummary = section.querySelector('[data-dc-order-summary]');
      if (orderSummary) orderSummary.textContent = orderSummary.dataset.dcTemplate.replace('__total__', money(total)).replace('__count__', String(count * 4));
      section.querySelector('[data-dc-sticky-count]').textContent = count + ' × ' + section.querySelector('h1').textContent;
      stickyVisibility();
      if (status && !busy) status.textContent = available ? '' : section.dataset.dcUnavailable;
      if (chosen) {
        void showImage(chosen);
        const url = new URL(location.href);
        url.searchParams.set('variant', chosen.dataset.dcVariant);
        history.replaceState(null, '', url);
      }
    };
    section.querySelectorAll('[data-dc-option]').forEach((choice) => {
      listen(choice, 'change', () => {
        if (!choice.checked) return;
        pieces[active][Number(choice.dataset.dcOption) - 1] = choice.value;
        update();
      });
    });
    section.querySelectorAll('[data-dc-piece-option]').forEach((select) => {
      listen(select, 'change', () => {
        active = Number(select.closest('[data-dc-piece]').dataset.dcPiece) - 1;
        pieces[active][Number(select.dataset.dcPieceOption) - 1] = select.value;
        update();
      });
    });
    listen(coneChoice, 'change', update);
    form?.querySelectorAll('[name="quantity"]').forEach((input) => listen(input, 'change', update));
    listen(form, 'submit', async (event) => {
      event.preventDefault();
      if (busy || buy?.disabled) return;
      const items = [];
      for (const piece of pieces.slice(0, quantity())) {
        const variant = findVariant(piece);
        if (variant?.dataset.dcReady !== 'true') { update(); return; }
        const existing = items.find((item) => item.id === variant.dataset.dcVariant);
        if (existing) existing.quantity += 1;
        else items.push({ id: variant.dataset.dcVariant, quantity: 1, properties: { 'Gratis do każdej sztuki': '4 pachołki' } });
      }
      if (coneChoice?.checked) items.push({ id: coneChoice.dataset.dcId, quantity: 1 });
      busy = true;
      update();
      if (status) status.textContent = '';
      const route = window.Shopify?.routes?.root || '/';
      try {
        const response = await fetch(route + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
          signal: controller.signal
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || buy.dataset.dcErrorLabel);
        location.assign(route + 'cart');
      } catch (error) {
        busy = false;
        update();
        if (status && error.name !== 'AbortError') status.textContent = error.message || buy.dataset.dcErrorLabel;
      }
    });
    section.querySelectorAll('.dc-comparison-range').forEach((range) => {
      listen(range, 'input', () => range.closest('.dc-comparison').style.setProperty('--dc-split', range.value + '%'));
    });
    section.querySelectorAll('.dc-faq-list details').forEach((detail) => {
      listen(detail, 'toggle', () => {
        if (!detail.open) return;
        section.querySelectorAll('.dc-faq-list details').forEach((other) => { if (other !== detail) other.open = false; });
      });
    });
    listen(controller.signal, 'abort', () => animations.forEach((animation) => animation.cancel()));
    update();
  }
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setupDrifciak(document), { once: true });
else setupDrifciak(document);
document.addEventListener('shopify:section:load', (event) => setupDrifciak(event.target));
document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('[data-dc-section]').forEach((section) => {
    section.dcController?.abort();
    delete section.dataset.dcReady;
  });
});
